"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./ModalComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import ReactDOM from "react-dom";
// import BackdropComponent from "../backdrop/BackdropComponent";
var ModalComponent = function ModalComponent(_ref) {
  var _ref$destroyOnClose = _ref.destroyOnClose,
      destroyOnClose = _ref$destroyOnClose === void 0 ? false : _ref$destroyOnClose,
      closable = _ref.closable,
      centered = _ref.centered,
      _ref$afterClose = _ref.afterClose,
      afterClose = _ref$afterClose === void 0 ? null : _ref$afterClose,
      confirmLoading = _ref.confirmLoading,
      closeIcon = _ref.closeIcon,
      cancelText = _ref.cancelText,
      okText = _ref.okText,
      focusTriggerAfterClose = _ref.focusTriggerAfterClose,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? "" : _ref$footer,
      autoFocusButton = _ref.autoFocusButton,
      icon = _ref.icon,
      keyboard = _ref.keyboard,
      mask = _ref.mask,
      visible = _ref.visible,
      showModal = _ref.showModal,
      handleOk = _ref.handleOk,
      handleCancel = _ref.handleCancel,
      button = _ref.button,
      children = _ref.children,
      className = _ref.className,
      width = _ref.width,
      height = _ref.height,
      _ref$bodyCls = _ref.bodyCls,
      bodyCls = _ref$bodyCls === void 0 ? "" : _ref$bodyCls;
  return /*#__PURE__*/_react["default"].createElement(_antd.Modal, {
    footer: footer,
    onOk: handleOk,
    onCancel: handleCancel,
    destroyOnClose: destroyOnClose,
    visible: visible ? visible : false,
    closable: closable ? closable : false,
    centered: centered ? centered : false,
    afterClose: afterClose,
    confirmLoading: confirmLoading ? confirmLoading : false,
    closeIcon: closeIcon ? closeIcon : false,
    cancelText: cancelText ? cancelText : "",
    okText: okText ? okText : "",
    focusTriggerAfterClose: focusTriggerAfterClose ? focusTriggerAfterClose : false,
    autoFocusButton: autoFocusButton ? autoFocusButton : "",
    icon: icon || "",
    keyboard: keyboard ? keyboard : false,
    mask: mask || true,
    className: "iiht-ant-modal ".concat(className || ""),
    width: width || "32.5rem",
    height: height || "30rem",
    getContainer: ".content"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-wrapper ".concat(bodyCls)
  }, children));
};

var _default = ModalComponent;
exports["default"] = _default;